import { getAccommodations, getExtendedCourses } from "../../services/faculty/v1/faculty";
import { getIXGrades } from "../../services/student/v1/student";
import { GET_STUDENT_ACCOMMODATIONS,  GET_EXTENDED_COURSES, GET_IX_GRADES} from "./actionTypes";

export const getStudentAccommodations = (getAcknowledgementObject) => async (dispatch, getState) => {
  const state = getState();
  
  // Check if user is authenticated before making API call
  if (!state.demographics.issuerId) {
    return;
  }
  
  await  getAccommodations(getAcknowledgementObject)
    .then((response) => {
      dispatch({ type: GET_STUDENT_ACCOMMODATIONS, payload: response.data });
    })
    .catch((error) => {
      dispatch({ type: GET_STUDENT_ACCOMMODATIONS, payload: error.request });
    });
};

export const getExtendedCoursesForIrn = (irn) => async (dispatch, getState) => {
  const state = getState();
  
  // Check if user is authenticated before making API call
  if (!state.demographics.issuerId) {
    return;
  }
  
  await  getExtendedCourses(irn)
    .then((response) => {
      dispatch({ type: GET_EXTENDED_COURSES, payload: response.data });
    })
    .catch((error) => {
      dispatch({ type: GET_EXTENDED_COURSES, payload: error.request });
    });
};

export const getIXGradesForCourse = (courseOfferingId) => async (dispatch, getState) => {
  const state = getState();
  
  // Check if user is authenticated before making API call
  if (!state.demographics.issuerId) {
    return;
  }
  
  // Check if data already exists and is not in error state
  const existingData = state.ixGrades?.[courseOfferingId];
  if (existingData && !existingData.error && existingData.data) {
    return;
  }
  
  // Dispatch loading state
  dispatch({ 
    type: GET_IX_GRADES, 
    payload: { courseOfferingId, loading: true } 
  });
  
  await getIXGrades(courseOfferingId)
    .then((response) => {
      dispatch({ 
        type: GET_IX_GRADES, 
        payload: { courseOfferingId, data: response.data, loading: false } 
      });
    })
    .catch((error) => {
      // Only treat as error if it's a server error (5xx) or network error
      // 404 means no IX grades found, which is expected and not an error
      const status = error.response?.status;
      const isActualError = !status || status >= 500;
      
      dispatch({ 
        type: GET_IX_GRADES, 
        payload: { 
          courseOfferingId, 
          data: status === 404 ? [] : null, // Empty array for 404, null for actual errors
          error: isActualError ? (error.message || "Failed to fetch IX grades") : null, 
          loading: false 
        } 
      });
    });
};